module.exports = __webpack_public_path__ + "static/ruler-crossed-out.670013557133babfc43758895345bed9.svg";